/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { configureStore } from '@reduxjs/toolkit';

import appStateReducer from './features/appStateSlice';

import filtersReducer from './features/filtersSlice';

import jobSelectionReducer from './features/jobSelectionSlice';

export const store = configureStore({
  reducer: {
    appState: appStateReducer,
    filters: filtersReducer,
    jobSelection: jobSelectionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
